<ul *ngIf="isDropdownActive" class="navbar-nav flex-row align-items-center dropdown-menu-sm-left">
  <li ngbDropdown class="nav-item dropdown me-2">
    <button ngbDropdownToggle 
      [disabled]="buildingUnits?.length === 0" 
      [ngClass]="buildingUnits?.length > 0? 'btn-primary' : 'btn-secondary' " 
      class="btn dropdown-toggle py-2  waves-effect waves-light" 
      type="button" 
      id="livePreview" 
      aria-expanded="false">
      <i class="fa-regular fa-buildings me-2"></i>
      <span [ngClass]="{'d-none d-md-inline': true}">
        {{selectedUnit?.name}}
      </span>
      <span *ngIf="!selectedUnit">Please Add Units!</span>
    </button>
    <ul ngbDropdownMenu  class="dropdown-menu" aria-labelledby="livePreview">
      <li  *ngFor="let item of facility" (click)="selectBuilding(item)">
        <small class="ms-3 text-secondary">The Facility:</small>
        <a ngbDropdownItem href="javaScript:void(0)" class="dropdown-item">
          <i class="fa-regular fa-building me-2"></i>
          {{item.name}}
        </a>
      </li>
      <hr class="m-0" *ngIf="facility?.length > 0">
      <small class="ms-3 text-secondary">Units:</small>
      <li  *ngFor="let item of buildingUnits" (click)="selectBuilding(item)">
        <a ngbDropdownItem href="javaScript:void(0)" class="dropdown-item">
          <i class="fa-regular fa-school me-2"></i>
          {{item.name}}</a>
      </li>
    </ul>
  </li>
</ul>
